@if (risk) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <datamanagement-linkable
            #linkableProcessingPurpose
            typename="data processing"
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="[]"
            [orderByValueProperty]="true"
            [disabled]="true"
        >
        </datamanagement-linkable>
    }
}
